<script lang="ts">
  import { getContext, onMount } from 'svelte';

  import Menu from '../Menu/Menu.svelte';
  import { ContextKeyLabel } from '$provider/constants/ContextKeyLabel';
  import { CredentialOverviewOption } from '$shared/constants/CredentialOverviewOption';

  const context = getContext<ReadonlyContextType>(ContextKeyLabel.Readonly);
  const UserActionOptions = [
    'edit',
    'verify',
    'remove',
    CredentialOverviewOption.Edit,
    CredentialOverviewOption.Remove
  ];

  interface Props {
    list?: CommonList[];
    onclick?: (detail: any) => void;
  }

  let { list = [], onclick }: Props = $props();

  let tempList = $state<CommonList[]>([]);

  onMount(() => {
    list && (tempList = list);
  });

  $effect(() => {
    tempList?.forEach((item: CommonList) => {
      if (!item.id) return;
      UserActionOptions?.includes(item.id) && (item.disabled = item.disabled || $context?.readonly);
    });
  });
</script>

{#if Array.isArray(tempList) && tempList.length !== 0}
  <div class="option-cell">
    <Menu list={tempList} {onclick} />
  </div>
{/if}

<style>
  .option-cell {
    width: 30px;
  }
</style>
